/**
 * When the request has been canceled via abortController different browsers produce different abortion messages (error.message):
 * Chrome & Edge: "Network failure: AbortError: The user aborted a request."
 * Firefox: "Network failure: AbortError: The operation was aborted."
 * Safari: "Network failure: AbortError: Fetch is aborted"
 *
 * DOMException errors happen when the component had been removed
 * before the ongoing request which leads to state changes
 * was resolved
 */

export const AbortErrors = {
	'Network failure: AbortError: The user aborted a request.': 'CHROME_EDGE_ABORT_ERROR',
	'Network failure: AbortError: The operation was aborted.': 'FIREFOX_ABORT_ERROR',
	'Network failure: AbortError: Fetch is aborted': 'SAFARI',
	'The user aborted a request.': 'CHROME_EDGE_DOMException_AbortError',
	'Fetch is aborted': 'SAFARI_DOMException_AbortError',
	'The operation was aborted.': 'FIREFOX_DOMException_AbortError',
};
